module.exports = __webpack_public_path__ + "static/media/cv_1.fcb59a99.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/cv_1.png
// module id = 613
// module chunks = 0